import script from "./ResumeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumeModal.vue?vue&type=script&setup=true&lang=js"

import "./ResumeModal.vue?vue&type=style&index=0&id=071630c8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-071630c8"]])

export default __exports__